import './App.css'
import MainContent from './containers/MainContent'
import MainContent2 from './containers/MainContent2'
import { Helmet } from 'react-helmet'
import { BrowserRouter as Router, Switch, Route, Link } from 'react-router-dom'
import GTMComponent from './components/GTMComponent'

function App() {
  return (
    <div style={{ height: '100%' }}>
      <Helmet>
        <meta charSet="utf-8" />
        <title>Ticketmelon Live Streaming</title>
        <link
          rel="shortcut icon"
          type="image/x-icon"
          href="https://s3-ap-southeast-1.amazonaws.com/asset.ticketmelon.com/images/logo.png"
        />
        <link
          rel="stylesheet"
          href="https://fonts.googleapis.com/css?family=Barlow:400,500,600&display=swap"
        />
        <link
          rel="stylesheet"
          href=" https://fonts.googleapis.com/css?family=Montserrat:400,500,600&display=swap"
        />
         <link
          rel="stylesheet"
          href=" https://fonts.googleapis.com/css?family=Avenir:400,500,600&display=swap"
        />
        <meta name="viewport" content="minimum-scale=1, initial-scale=1, width=device-width" />
        <meta
          name="description"
          content="Ticketmelon is an easy to use ticketing platform for all types of experiences. Discover events you’ll love, or create your own and sell tickets."
        />
        <meta
          name="keywords"
          content="ticketmelon,ticketing,event,EDM,party,booking,organizer,music,fest,festival"
        />
        <meta name="agd-partner-manual-verification" content="" />
        <meta name="twitter:title" property="twitter:title" content="Ticketmelon" />
        <meta name="twitter:card" property="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:description"
          property="twitter:description"
          content="Ticketmelon is an easy to use ticketing platform for all types of experiences. Discover events you’ll love, or create your own and sell tickets."
        />
        <meta
          name="twitter:image"
          property="twitter:image"
          content="https://s3-ap-southeast-1.amazonaws.com/tm-public-file/TMLogo.png"
        />
        <meta name="og:title" property="og:title" content="Ticketmelon" />
        <meta
          name="og:image"
          property="og:image"
          content="https://s3-ap-southeast-1.amazonaws.com/tm-public-file/TMLogo.png"
        />
        <meta name="og:site_name" property="og:site_name" content="www.ticketmelon.com" />
        <meta
          name="og:description"
          property="og:description"
          content="Ticketmelon is an easy to use ticketing platform for all types of experiences. Discover events you’ll love, or create your own and sell tickets."
        />
      </Helmet>
      <Router>
        <Switch>
          <Route path="/event/:eventId">
            <MainContent />
          </Route>
          <Route path="/ylphanniversary/:eventId">
            <MainContent2 />
          </Route>
          <Route path="/">
            <div />
          </Route>
        </Switch>
      </Router>
      <GTMComponent />
    </div>
  )
}

export default App
